import api from "./api";

class Analytics {
  get(){
    return api.get(`v1/api/countries/analytics`);
  }
  getTypes() {
    return api.get(`v1/api/countries/analytics/analytic-types`);
  }
}

export default new Analytics();
